<p-sidebar  [(visible)]="visibleSidebar" position="right" [modal]="true" [baseZIndex]="999"
  styleClass="assign-parker-sidebar" (onShow)="onSidebarAction('hidden')" (onHide)="onSidebarAction('auto')">
  <p-confirmPopup></p-confirmPopup>
  <app-loader></app-loader>
  <p-toast></p-toast>
  <div class="assign-parker-outer">

    <div class="assign-close">
      <h3>Assign Parkers and Equipment</h3>
    </div>
    <div class="parker-main-outer">
      <div class="total-spots">
        <h5>Please provide the list of parkers and their equipment for this group booking.</h5>
        <div class="total-add-parker">
          <p>Total Spots: <strong>{{ spotCount }}</strong></p>
        </div>
      </div>
    </div>

    <div class="table-outer">
      <table class="w-full">
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">Mobile</th>
            <th scope="col">Name</th>
            <th scope="col">LP Number</th>
            <th scope="col">DOT Number</th>
            <th scope="col">Make</th>
            <th scope="col">Color</th>
            <th scope="col" *ngIf="isGateAccessLinkVisible">Gate Access Link</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="assignedSlotList?.length > 0">
            <tr *ngFor="let entry of assignedSlotList; let i = index">
              <td>
                <div class="custom-borders">{{ entry?.email || '-' }}</div>
              </td>
              <td>
                <div class="mobile-number custom-borders flag-outer"><span *ngIf="entry?.mobileNumber"
                    [ngClass]="getFlagClass(entry?.iso)"></span>{{ entry.countryCode &&
                  entry.mobileNumber ? (entry.countryCode + ' ' + entry.mobileNumber) : '-' }}</div>
              </td>
              <td>
                <div class="custom-borders">{{ (entry?.firstName || '') + ' ' + (entry?.lastName || '') || '-' }}</div>
              </td>
              <td>
                <div class="custom-borders">{{ entry?.licencePlateNumber || '-' }}</div>
              </td>
              <td>
                <div class="custom-borders">{{ entry?.dotNumber || '-'}}</div>
              </td>
              <td>
                <div class="custom-borders">{{ entry?.make || '-' }}</div>
              </td>
              <td class="date-filter">
                <div class="dropdown-icon color-outer">
                  <div class="entry-color custom-borders"><span class="entry-colors">{{ entry?.color || '-' }}</span>
                  </div>
                </div>
              </td>
              <td *ngIf="isGateAccessLinkVisible">
                <div class="share" (click)="shareGateAccessLink(entry)">
                  Share
                </div>
              </td>
              <td>
                <div class="plus-outer">
                  <img src="../../../../assets/images/minus-icon.svg" alt=""
                    (click)="DeleteAssignedGroupBookingDriver($event,entry)" />
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="newEntry">
            <tr [formGroup]="entryForm">
              <td>
                <div class="custom-select2 custom-multiselect">
                  <p-dropdown formControlName="emailAddress" [options]="filteredEmails" optionLabel="email"
                    placeholder="Enter Email" [filter]="true" filterBy="email" [showClear]="false" [maxlength]="50"
                    (onChange)="onEmailSelect($event)" (onFilter)="filterParkerFields($event, 'email')"
                    [emptyFilterMessage]="'No Email Found'"></p-dropdown><img src="assets/images/fill-dropdown.svg"
                    alt="" />
                       </div>
                  <div
                    *ngIf="entryForm.get('emailAddress').invalid && (entryForm.get('emailAddress').dirty || entryForm.get('emailAddress').touched)">
                    <div *ngIf="entryForm.get('emailAddress')?.hasError('pattern')">Please enter a valid email*.</div>
                    <small class="validation-error" *ngIf="entryForm.get('emailAddress')?.hasError('required')">Field is required*</small>
                  </div>
             
              </td>
              <td class="custom-country-code">
                <div class="formgrid country-code custom-select2 custom-multiselect">
                  <p-dropdown formControlName="mobile" [options]="filteredMobiles" optionLabel="mobileNumber"
                    placeholder="Enter Mobile Number" [filter]="true" filterBy="mobileNumber" [showClear]="false"
                    [maxlength]="50" (onChange)="onMobileNumberSelect($event)"
                    (onFilter)="filterParkerFields($event, 'email')" [emptyFilterMessage]="'No Email Found'">
                  </p-dropdown>
                  <img src="assets/images/fill-dropdown.svg" alt="" />
                </div>
                 <div
                  *ngIf="!entryForm.get('mobile').hasError('pattern') && entryForm.get('mobile').touched && entryForm.get('mobile').invalid">
                  <small class="validation-error">Field is required*</small>
                </div>
              </td>
              <td>
                <input type="text" formControlName="name" placeholder="Enter Name" maxlength="50" pInputText />
                <div
                  *ngIf="entryForm.get('name')?.hasError('required') && (entryForm.get('name')?.dirty || entryForm.get('name')?.touched)">
                  <small class="validation-error">Field is required*</small>
                </div>

                <div
                  *ngIf="entryForm.get('name')?.hasError('pattern') && (entryForm.get('name')?.touched || entryForm.get('name')?.dirty)"
                  class="validation-error">
                  Please enter only characters*
                </div>

                <div
                  *ngIf="!entryForm.get('name')?.hasError('pattern') && entryForm.get('name')?.hasError('minlength') && (entryForm.get('name')?.touched || entryForm.get('name')?.dirty)"
                  class="validation-error">
                  Minimum 3 characters are required*
                </div>
                <div
                  *ngIf="entryForm.get('name')?.hasError('maxlength') && (entryForm.get('name')?.touched || entryForm.get('name')?.dirty)"
                  class="validation-error">
                  Maximum 50 characters are required*
                </div>
              </td>
              <td>
                <div class="custom-select2 custom-multiselect">
                  <p-dropdown formControlName="licenseNumberPlateName" [options]="filteredLps"
                    optionLabel="licenseNumberPlate" placeholder="Enter LP Number" [filter]="true"
                    filterBy="licenseNumberPlate" [showClear]="false" [maxlength]="15" (onChange)="onLpSelect($event)"
                    (onFilter)="filterEquipmentFields($event)" [emptyFilterMessage]="'No LP Found'">
                  </p-dropdown><img src="assets/images/fill-dropdown.svg" alt="" />
                </div>
                <div *ngIf="entryForm.get('licenseNumberPlateName').touched">
                  <div *ngIf="entryForm.get('licenseNumberPlateName').hasError('required'); else patternError">
                    <div class="validation-error">Field is required*</div>
                  </div>

                  <ng-template #patternError>
                    <div *ngIf="entryForm.get('licenseNumberPlateName').hasError('pattern'); else maxLengthError">
                      <div class="validation-error">License Plate Number is invalid.</div>
                    </div>
                  </ng-template>

                  <ng-template #maxLengthError>
                    <div *ngIf="entryForm.get('licenseNumberPlateName').hasError('maxlength'); else minLengthError">
                      <div class="validation-error">Max. 15 characters are required.</div>
                    </div>
                  </ng-template>

                  <ng-template #minLengthError>
                    <div *ngIf="entryForm.get('licenseNumberPlateName').hasError('minlength')">
                      <div class="validation-error">Min. 5 characters are required.</div>
                    </div>
                  </ng-template>
                </div>
              </td>
              <td>
                <input type="text" formControlName="dotNumber" placeholder="Enter DOT Number" maxlength="12"
                  minlength="6" oninput="this.value = this.value.toUpperCase()" pattern="^[A-Za-z0-9]+$" pInputText />
                <div *ngIf="entryForm.get('dotNumber').touched">
  
                  <div *ngIf="entryForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">DOT Number is invalid.</div>
                  </div>
                  <div
                    *ngIf="entryForm.get('dotNumber').hasError('maxlength') && !entryForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">Max. 12 digits are required.</div>
                  </div>
                  <div
                    *ngIf="entryForm.get('dotNumber').hasError('minlength') && !entryForm.get('dotNumber').hasError('pattern')">
                    <div class="validation-error">Min. 6 digits are required.</div>
                  </div>
                </div>
              </td>

              <td class="date-filter">
                <div class="custom-select2 dropdown-index">
                  <input type="text" formControlName="make" placeholder="Enter Make" maxlength="50" pInputText />
                </div>
                <div
                  *ngIf="entryForm.get('make')?.hasError('required') && (entryForm.get('make')?.dirty || entryForm.get('make')?.touched)">
                  <div class="validation-error">Field is required*</div>
                </div>
              </td>

              <td class="date-filter">
                <div class="dropdown-icon color-outer">
                  <div class="custom-select2 dropdown-index select-color">
                    <input type="text" formControlName="color" placeholder="Enter Color" maxlength="50" pInputText />
                    <div
                      *ngIf="entryForm.get('color')?.hasError('required') && (entryForm.get('color')?.dirty || entryForm.get('color')?.touched)">
                      <div class="validation-error">Field is required*</div>
                    </div>
                  </div>

                </div>
              </td>
               <td *ngIf="isGateAccessLinkVisible">
                <div class="share">-</div>
              </td>
              <td>
                <div class="plus-outer">
                  <img src="../../../../assets/images/plus-icon.svg" alt="" (click)="saveEntry(entryForm.value)" />
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</p-sidebar>